import { OrganisationSettingsResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, OrganisationSettings } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetOrganisationsSettings extends BaseAdapter<OrganisationSettingsResponse> implements AdapterInterface {
  rawResponse: OrganisationSettingsResponse;

  async adaptResponse(): Promise<OrganisationSettings> {
    await this.fetchApiResponse('/api/organisation-settings', HTTPMethod.Get);
    return {
      isSendToCalculatorEnabled: this.rawResponse.is_send_to_calculator_enabled,
      isCampaignEnabled: this.rawResponse.is_campaign_enabled,
    };
  }
}
